import { Button, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { RuleSetSelectionDialog } from "./rule-set-selection-dialog"

export function RuleSetSection({ ruleSetItems = [], selectedRuleSets = [], onSelect }) {
    const openSelectionDialog = useDialog(<RuleSetSelectionDialog />, { maxWidth: "sm", fullWidth: true })
    const selectedCount = selectedRuleSets?.length ?? 0
    const fieldColor = getFieldColor()
    const fieldBorderColor = getFieldBorderColor()

    return (
        <Stack spacing={1.5}>
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Iconify icon="tabler:filter-cog" width={20} height={20} sx={{ color: "common.black" }} />
                    <Typography variant="subtitle1" fontWeight={600}>
                        Rule Set
                    </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    Apply a set of rules to your regime (optional)
                </Typography>
            </Stack>
            <Button
                data-cy="rule-set-selector"
                variant="outlined"
                fullWidth
                onClick={handleOpenSelectionDialog}
                endIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
                sx={{
                    justifyContent: "space-between",
                    px: 2,
                    py: 1.25,
                    color: fieldColor,
                    borderColor: fieldBorderColor,
                    textTransform: "none",
                    fontWeight: 500,
                }}
            >
                {formatFieldLabel()}
            </Button>
            <If value={selectedCount > 0}>
                <Typography variant="caption" color="text.secondary">
                    {formatSelectedRuleSets()}
                </Typography>
            </If>
        </Stack>
    )

    async function handleOpenSelectionDialog() {
        const result = await openSelectionDialog({
            ruleSetItems,
            selectedRuleSets,
        })
        if (!Array.isArray(result)) return
        onSelect(result)
    }

    function getFieldColor() {
        if (selectedCount > 0) return "text.primary"
        return "text.secondary"
    }

    function getFieldBorderColor() {
        if (selectedCount > 0) return "primary.main"
        return "divider"
    }

    function formatFieldLabel() {
        if (selectedCount === 0) return "Select rule sets..."
        if (selectedCount === 1) return selectedRuleSets[0]?.name || "1 rule set selected"
        return `${selectedCount} rule sets selected`
    }

    function formatSelectedRuleSets() {
        return selectedRuleSets.map(toRuleSetName).filter(Boolean).join(", ")
    }

    function toRuleSetName(ruleSet) {
        return ruleSet.name || ruleSet.id
    }
}
